module.exports = __webpack_public_path__ + "img/crop.21eeecd8.svg";